import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "features" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "copy" }
const _hoisted_4 = {
  key: 0,
  class: "points"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
      return _withDirectives((_openBlock(), _createElementBlock("li", {
        key: feature.titleKey,
        class: _normalizeClass({ visual: feature.src })
      }, [
        (feature.src)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: feature.src,
              alt: _ctx.t(feature.titleKey)
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.t(feature.titleKey)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t(feature.bodyKey)), 1),
          (feature.pointKeys?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.pointKeys, (key) => {
                  return (_openBlock(), _createElementBlock("span", { key: key }, _toDisplayString(_ctx.t(key)), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)), [
        [_directive_home_reveal]
      ])
    }), 128))
  ]))
}